import React, { useEffect, useState } from 'react'
import UtilsBufer from '../Tools/UtilsBufer';
import UtilsMath from '../Tools/UtilsMath';
const server = process.env.REACT_APP_SERVER;

function ItemSucursalVentaDiaria(props) {
    const { sucursal, actualizar, info } = props;
    const [datos, setDatos] = useState([]);
    const [isLoad,setIsLoad] = useState(false);
    function obtenerDatos() {
        fetch(`${server}/supervision/getProVentaDiaria`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: info.regional, idSucursal: sucursal.ID_SUCURSAL, fecha: info.fecha
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    console.log(data.error);
                } else {
                    setDatos(data.ok);
                    console.log(data.ok)
                }
                setIsLoad(true);
            })
            .catch(error => console.log(error));
    }
    function redondeBandeja(valor){
        console.log(valor,(valor*100)%100)
        if(parseInt((valor*100)%100) != 0){
            return 1
        }else{
            return 0
        }
    }
    useEffect(() => {
        setIsLoad(false);
        obtenerDatos();
    }, [actualizar])
    return (
        <div className=''>
            <div className='text-center text-light fw-bold fs-3 '>
                {sucursal.SUCURSAL}
            </div>
            {isLoad==false&&<div className='text-center'><i className="fa-solid fa-spinner fa-spin fa-2xl"></i></div>}
            {isLoad&&<ul className="list-group ">
                {datos.map((item, index) => {
                    return (
                        <li className={`overflow-auto list-group-item ${index == 0 ? 'fondoNaranja' : 'fondoHeader'}`} key={index}>
                            <div className='text-center fw-bold text-light'>
                                {index == 0 ? `POLLO BANDEJAS PROYECTADO ` : `PIPOCA PORCIONES PROYECTADO `}
                                <span className='badge fondoPlomoOscuro text-light fs-5'>{item.TOTALP}</span>
                                {index == 0 ? ` POLLO BANDEJAS OBJETIVO ` : ` PIPOCA PORCIONES OBJETIVO `}
                                <span className='badge fondoNaranjaClaro text-dark fs-5'>{index == 0 ? UtilsMath.redondeoPersonalizado(Math.max(item.TOTALP - Math.round(item.TOTALINV/100), 0), 1, 2) + Math.round(item.TOTALINV/100) : Math.max(item.TOTALP - UtilsMath.redondeoPersonalizado(item.TOTALINV, 25, 40), 0) + item.TOTALINV}</span>
                            </div>
                            <ul className="list-group list-group-horizontal ">
                                {index == 0 && <li className="list-group-item fondoNaranjaClaro my-auto">
                                    <div className='text-center'>
                                        <div>Inventario Crudo</div>
                                        <ul className="list-group list-group-horizontal">
                                            <li className='list-group-item bg-success'>
                                                <div className='lh-1 text-light' style={{ fontSize: '10px' }}>octavos</div>
                                                <div className='fw-bold text-light'>{parseInt((item.INVCRUDO))}</div>
                                            </li>
                                            <li className='list-group-item'>
                                                <div className='lh-1' style={{ fontSize: '10px' }}>Bandejas</div>
                                                <div className='fw-bold '>{Math.trunc(item.INVCRUDO/100)}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>}
                                {index == 0 && <li className="list-group-item fondoNaranjaClaro my-auto">
                                    <div className='text-center'>
                                        <div>Inventario Marinado</div>
                                        <ul className="list-group list-group-horizontal ">
                                            <li className='list-group-item bg-success '>
                                                <div className='lh-1 text-light' style={{ fontSize: '10px' }}>octavos</div>
                                                <div className='fw-bold text-light'>{parseInt((item.INVMARINADO))}</div>
                                            </li>
                                            <li className='list-group-item'>
                                                <div className='lh-1' style={{ fontSize: '10px' }}>Bandejas</div>
                                                <div className='fw-bold'>{Math.round(item.INVMARINADO/100)}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>}
                                {index == 0 && <li className="list-group-item fondoNaranjaClaro my-auto">
                                    <div className='text-center'>
                                        <div className='lh-1' style={{ fontSize: '12px' }}>Inventario Pollo<br></br>Marinado+Crudo</div>
                                        <ul className="list-group list-group-horizontal">
                                            <li className='list-group-item bg-success'>
                                                <div className='lh-1 text-light' style={{ fontSize: '10px' }}>octavo</div>
                                                <div className='fw-bold text-light'>{parseInt(((item.INVCRUDO + item.INVMARINADO)))}</div>
                                            </li>
                                            <li className='list-group-item'>
                                                <div className='lh-1' style={{ fontSize: '10px' }}>Bandejas</div>
                                                <div className='fw-bold'>{Math.round((item.INVCRUDO + item.INVMARINADO)/100)}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </li>}
                                {index == 1 && <li className="list-group-item my-auto fondoPlomoClaro">
                                    <div className='text-center lh-1'>
                                        <div>Inventario<br></br>Porciones</div>
                                        <div className='fw-bold list-group-item'>{item.TOTALINV}</div>
                                    </div>
                                </li>}
                                <li className={`list-group-item my-auto ${index == 0 ? 'fondoNaranjaClaro' : 'fondoPlomoClaro'}`}>
                                    <div className='text-center '>
                                        <div>CRUDO NOCHE</div>
                                        <div className='fw-bold list-group-item'>{item.REQ0}</div>
                                    </div>
                                </li>
                                <li className={`list-group-item my-auto ${index == 0 ? 'fondoNaranjaClaro' : 'fondoPlomoClaro'}`}>
                                    <div className='text-center '>
                                        <div>CRUDO MAÑANA</div>
                                        <div className='fw-bold list-group-item'>{item.REQ1}</div>
                                    </div>
                                </li>
                                <li className={`list-group-item my-auto ${index == 0 ? 'fondoNaranjaClaro' : 'fondoPlomoClaro'}`}>
                                    <div className='text-center'>
                                        <div>MARINADO 12 AM</div>
                                        <div className='fw-bold list-group-item'>{item.REQ2}</div>
                                    </div>
                                </li>
                                <li className={`list-group-item my-auto ${index == 0 ? 'fondoNaranjaClaro' : 'fondoPlomoClaro'}`}>
                                    <div className='text-center'>
                                        <div>MARINADO 5 AM</div>
                                        <div className='fw-bold list-group-item'>{item.REQ3}</div>
                                    </div>
                                </li>
                                <li className={`list-group-item my-auto ${index == 0 ? 'fondoNaranjaClaro' : 'fondoPlomoClaro'}`}>
                                    <div className='text-center'>
                                        <div>MARINADO 12 PM</div>
                                        <div className='fw-bold list-group-item'>{index == 0 ? item.REQ4 : item.REQ5}</div>
                                    </div>
                                </li>
                                {index == 0 && <li className="list-group-item my-auto fondoNaranjaClaro">
                                    <div className='text-center'>
                                        <div>MARINADO 15 PM</div>
                                        <div className='fw-bold list-group-item'>{item.REQ5}</div>
                                    </div>
                                </li>}
                                {index == 1 && <li className="list-group-item my-auto fondoPlomoClaro">
                                    <div className='text-center lh-1'>
                                        <div className='lh-1' style={{fontSize:'10px'}}>Observaciones</div>
                                        <textarea className="form-control" readOnly style={{width:'320px',maxHeight:'56px'}}
                                            value={UtilsBufer.getText(item.OBSERVACIONES)}></textarea>
                                    </div>
                                </li>}
                            </ul>
                        </li>
                    )
                })}
            </ul>}
        </div>
    )
}

export default ItemSucursalVentaDiaria